import { BiddingDeclarationView, BiddingView } from '../../../graphql/types.gen.ts';
import { bidValueToNumber, compareTwoBids } from '../../../helpers.ts';
import { emptyBid } from '../../Sequence/ComplexSequence.tsx';
import { TRUMPS } from '../BiddingUI.tsx';

export const useBidLimitations = (wholeSequence: BiddingView[], editMode: boolean) => {
	const theSequenceIsEmpty = wholeSequence.length === 1 && compareTwoBids(wholeSequence[0], emptyBid);
	const theSequenceIsAfterPassesOnly =
		wholeSequence.slice(0, -1).filter((item) => item?.declaration !== BiddingDeclarationView.Pass).length === 0 &&
		compareTwoBids(wholeSequence.slice(-1)[0], emptyBid);

	if (theSequenceIsEmpty || theSequenceIsAfterPassesOnly || editMode) {
		return {
			canUseKtr: false,
			canUseRktr: false,
			lowestPossibleNumber: 1,
			lowestPossibleTrump: 0,
		};
	}

	const isNormalBid = (item) => {
		return item?.declaration === 'BID';
	};

	const currentHighestItem = wholeSequence
		.filter((item) => {
			return isNormalBid(item) && !compareTwoBids(item, emptyBid);
		})
		.slice(-1)[0];

	const lowestPossibleNumber: number =
		currentHighestItem?.bidCard.color === 'NO_TRUMPS'
			? bidValueToNumber(currentHighestItem?.bidCard.value) + 1
			: bidValueToNumber(currentHighestItem?.bidCard.value);

	const lowestPossibleTrump: number =
		currentHighestItem?.bidCard.color === 'NO_TRUMPS' ? -1 : TRUMPS.indexOf(currentHighestItem?.bidCard.color) + 1;

	const lastItem = wholeSequence[wholeSequence.length - 1];
	const secondLastItem = wholeSequence[wholeSequence.length - 2];
	const thirdLastItem = wholeSequence[wholeSequence.length - 3];

	const canUseKtr = () => {
		const lastIsNormalBid = isNormalBid(lastItem);
		const isBidFollowedByTwoPasses =
			isNormalBid(thirdLastItem) &&
			secondLastItem?.declaration === BiddingDeclarationView.Pass &&
			lastItem?.declaration === BiddingDeclarationView.Pass;

		return lastIsNormalBid || isBidFollowedByTwoPasses;
	};
	const canUseRktr = () => {
		const lastIsDouble = lastItem?.declaration === BiddingDeclarationView.Double;
		const isDoubleFollowedByTwoPasses =
			thirdLastItem?.declaration === BiddingDeclarationView.Double &&
			secondLastItem?.declaration === BiddingDeclarationView.Pass &&
			lastItem?.declaration === BiddingDeclarationView.Pass;

		return lastIsDouble || isDoubleFollowedByTwoPasses;
	};

	return {
		canUseKtr,
		canUseRktr,
		lowestPossibleNumber,
		lowestPossibleTrump,
	};
};
